import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, FormField } from '@domain-group/suit-theme'

import { TaskListItemModel } from '@models/taskListItem'

import useRelatedEntity from '@hooks/useRelatedEntity'
import useRelatedEntities from '@hooks/useRelatedEntities'

import BlankState from '@components/BlankState'

import RelatedEntity from './RelatedEntity'

import ConnectionsImageUrl from './assets/connections.svg'

interface ConnectionsProps {
  callbacks: {
    deleteRelatedEntity: () => void,
  },
  taskListItem: TaskListItemModel,
}

const Connections = (props: ConnectionsProps) => {
  const { callbacks: { deleteRelatedEntity }, taskListItem } = props

  const relatedEntitiesPayload = useRelatedEntities({
    filters: {
      owner_id: taskListItem.id,
      owner_type: 'TaskListItem',
    },
  })

  const { filteredRelatedEntities, hasFilteredRelatedEntities } = relatedEntitiesPayload

  const relatedEntityPayload = useRelatedEntity({ owner_id: taskListItem.id, owner_type: 'TaskListItem' })
  const { callbacks: { createOrEditRelatedEntity } } = relatedEntityPayload

  return (
    <FormField boxProps={{ width: 'calc(100% - 345px - 16px)' }} label="Connections">
      <Box flexDirection="column" height={316} variant="white">
        <Box
          justifyContent={hasFilteredRelatedEntities ? undefined : 'center'}
          flexDirection="column"
          height={250}
          overflowY="auto"
        >
          {!hasFilteredRelatedEntities && (
            <BlankState
              imageUrl={ConnectionsImageUrl}
              title="No Connections"
              subtitle="Connect your task to other entities that relate to the project."
            />
          )}

          {filteredRelatedEntities.map(relatedEntity => (
            <RelatedEntity
              callbacks={{ deleteRelatedEntity }}
              key={relatedEntity.id}
              relatedEntity={relatedEntity}
            />
          ))}
        </Box>

        <Box borderTop="1px solid" borderColor="lineColor" padding="large">
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditRelatedEntity()}
            marginLeft="auto"
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Connection
          </Button>
        </Box>
      </Box>
    </FormField>
  )
}

export default Connections
